import { Reducer } from 'redux'
import { ActionTypes, initialState, SmartCard } from './types'

const reducer: Reducer<SmartCard> = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.CERTIFICATE_LIST_FULFILLED: {
      return {
        ...state,
        certificateList: action.payload.data,
        erroDescription: undefined,
      }
    }
    case ActionTypes.CERTIFICATE_LIST_REQUEST: {
      return {
        ...state,
        errorDescription: undefined,
      }
    }

    case ActionTypes.CERTIFICATE_LIST_REJECTED: {
      return {
        ...state,
        certificateList: [],
        errorDescription: action.payload.response.data.message,
      }
    }
    case ActionTypes.TERMINAL_LIST_FULFILLED: {
      return {
        ...state,
        terminalList: action.payload.data.cards,
        osArch: action.payload.data.osArch,
        osName: action.payload.data.osName,
        osVersion: action.payload.data.osVersion,
      }
    }
    case ActionTypes.SET_STATE: {
      return {
        ...state,
        [action.payload.key]: action.payload.value,
      }
    }
    case ActionTypes.SET_SMART_CARD: {
      return action.payload
    }
    default: {
      return state
    }
  }
}

export default reducer
